import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import FileDropzone from '../FileDropzone/FileDropzone';
import Api from '../../../services/Api';

const AudioCitation = ({
  onChanged,
  onRequestClose,
}) => {
  const onFileUploaded = (file) => {
    const data = {
      file_id: file[0],
      resource_type_id: 3,
      title: 'Audio File',
    };
    Api.post('citations', data).then((response) => {
      if (response.status === 201) {
        if (onChanged) {
          onChanged(response.data);
        }
      }
    });
  };
  return (
    <div className="row">
      <div className="col-md-12">
        <FileDropzone
          onFilesChanged={onFileUploaded}
          endpoint="documents/upload"
          allowedFiles={{
            'audio/*': ['.mp3', '.wav'],
          }}
        />
      </div>
      <div className="col-md-12 text-end mt-5">
        <Button variant="warning" onClick={onRequestClose} className="me-3">
          Close
        </Button>
      </div>
    </div>
  );
};

AudioCitation.propTypes = {
  onChanged: PropTypes.func,
  onRequestClose: PropTypes.func.isRequired,
};

AudioCitation.defaultProps = {
  onChanged: undefined,
};

export default AudioCitation;
